import { render, staticRenderFns } from "./productreport.vue?vue&type=template&id=d8af2b1e&"
import script from "./productreport.vue?vue&type=script&lang=js&"
export * from "./productreport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports